<!--返回、退出登录按钮组件-->
<template>
	<div class="EConfigBtn">
		<button :style="{background:pushBg}" class="btn" @click="backUp()">{{Language.LG.PrevPage[isLanguage]}}</button>
		<button :style="{background:pushBg}" class="btn" @click="quit()">{{Language.LG.Quit[isLanguage]}}</button>
	</div>
</template>

<script>
	import { storage } from "../../../../static/js/utils/utility"
	export default {
		props:['pushBg','backUp','quit'],
		data(){
			return {
				isLanguage: 0,
				Language:'',
			}
		},
		created(){
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
		},
		
	}
</script>

<style lang="less">
.EConfigBtn{
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	display: flex;
	.btn{
		flex-grow: 1;
		height: 0.8rem;
		line-height: 0.8rem;
		font-size: 0.4rem;
		color: #fff;
		// background: #151c36;
		border-radius: 0;
		box-shadow: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/assets/ConfigBtn.vue